import { enc } from './core.js';
export function cajaApi(c) {
    const base = (localId) => `/locals/${enc(localId)}`;
    return {
        createSale: (localId, body) => c.post(`${base(localId)}/sales`, body),
        listSales: (localId, query = {}) => c.get(`${base(localId)}/sales`, { query: query }),
        getSale: (localId, saleId) => c.get(`${base(localId)}/sales/${enc(saleId)}`),
        voidSale: (localId, saleId, body) => c.post(`${base(localId)}/sales/${enc(saleId)}/void`, body),
        createExpense: (localId, body) => c.post(`${base(localId)}/expenses`, body),
        listExpenses: (localId, query = {}) => c.get(`${base(localId)}/expenses`, { query: query }),
        deleteExpense: (localId, id) => c.delete(`${base(localId)}/expenses/${enc(id)}`),
        createIncome: (localId, body) => c.post(`${base(localId)}/incomes`, body),
        listIncomes: (localId, query = {}) => c.get(`${base(localId)}/incomes`, { query: query }),
        deleteIncome: (localId, id) => c.delete(`${base(localId)}/incomes/${enc(id)}`),
        today: (localId) => c.get(`${base(localId)}/cash/today`),
        close: (localId, body) => c.post(`${base(localId)}/cash/close`, body),
        listCloses: (localId, query = {}) => c.get(`${base(localId)}/cash/closes`, { query: query }),
        getClose: (localId, closeId) => c.get(`${base(localId)}/cash/closes/${enc(closeId)}`),
    };
}
//# sourceMappingURL=caja.js.map